import { SPORTS } from './appConfig';

export const SPORTS_ALLOW_MATCH_CENTER = [
    SPORTS.TENNIS,
    SPORTS.ICE_HOCKEY,
    SPORTS.BASKETBALL,
    SPORTS.BADMINTON,
    SPORTS.FOOTBALL,
    SPORTS.AMERIKANSK_FODBOLD,
    SPORTS.DART,
    SPORTS.SNOOKER,
    SPORTS.BORDTENNIS,
    SPORTS.HANDBALL,
    SPORTS.BADMINTON,
    SPORTS.RUGBY,
    SPORTS.BASEBALL,
    SPORTS.CRICKET,
    SPORTS.FUTSAL,
    SPORTS.VOLLEYBALL,
    SPORTS.BEACH_VOLLEY,
    SPORTS.PADEL,
];
